import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Hero from './components/Hero';
import Services from './components/Services';
import Gallery from './components/Gallery';
import Portfolio from './components/Portfolio';

import Footer from './components/Footer';
import Navbar from './components/Navbar';
import EnquiryForm from './components/EnquiryForm';
import Demo from './components/Demo';
import "./App.css";





function App() {
  return (
    <Router>
      <div className="App">
        <Navbar />
        <Routes>
          <Route path="/" element={<Hero />} />
          <Route path="/services" element={<Services />} />
          <Route path="/Gallery" element={<Gallery/>} />
          <Route path="/portfolio" element={<Portfolio />} />
        
          <Route path="/Enq" element={<EnquiryForm/>}/>
          <Route path="*" element={<h1 className="text-center h-screen justify-center text-9xl">404 - Page Not Found</h1>} />
        
         <Route path="/Demo" element={<Demo/>}/>
        </Routes>
        <Footer />
      </div>
    </Router>

  );
}

export default App;
